import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from 'app/utils/providerHOC/providerHOC';
import WaitingListComponent from './waitingListPageContainer';

const { componentData } = window.waitingList;
const WaitingListComponentRoot = providerHOC()(WaitingListComponent);

createRoot(document.getElementById(componentData.id)).render(<WaitingListComponentRoot />);
